import { Link } from "react-router-dom";

const ENTRIES = [
  { to: "/category/movie", icon: "ri-film-line", title: "电影", desc: "院线热映 · 口碑佳片" },
  { to: "/category/tv", icon: "ri-tv-2-line", title: "电视剧", desc: "热门连载 · 全集速看" },
  { to: "/category/movie?genre=科幻", icon: "ri-rocket-2-line", title: "科幻片", desc: "太空 · 未来 · 硬核" },
  { to: "/category/movie?genre=悬疑", icon: "ri-spy-line", title: "悬疑片", desc: "烧脑推理 · 反转不断" },
  { to: "/category/tv?genre=古装", icon: "ri-ancient-gate-line", title: "古装剧", desc: "权谋江湖 · 探案风月" },
  { to: "/category/tv?genre=爱情", icon: "ri-heart-3-line", title: "爱情剧", desc: "都市心动 · 治愈慢热" },
];

export default function CategoryEntries() {
  return (
    <div className="grid grid-cols-2 gap-3 sm:grid-cols-3 md:gap-4 lg:grid-cols-6">
      {ENTRIES.map((entry) => (
        <Link
          key={entry.title}
          to={entry.to}
          className="group flex cursor-pointer flex-col items-center rounded-lg border border-background-200/80 bg-background-100/70 px-3 py-5 text-center transition-colors hover:border-primary-300 hover:bg-primary-50"
        >
          <span className="flex h-12 w-12 items-center justify-center rounded-full bg-background-50 text-primary-600 transition-colors group-hover:bg-primary-500 group-hover:text-background-50">
            <i className={`${entry.icon} text-2xl`}></i>
          </span>
          <span className="mt-3 text-sm font-medium text-foreground-900">{entry.title}</span>
          <span className="mt-1 text-[11px] leading-relaxed text-foreground-500">{entry.desc}</span>
        </Link>
      ))}
    </div>
  );
}